export default __webpack_public_path__ + "static/media/composite.508f83df.jpg";